import { selectors, actions } from '../../state';
import { STATES } from '../../constants';
import template from './app-header.html';
import './app-header.global.css';

class AppHeaderController {
  constructor(updStore, appShell) {
    'ngInject';
    Object.assign(this, { updStore, appShell });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  get companyLogoUiSref() {
    return STATES.DASHBOARD;
  }

  goToDashboard(event) {
    event.preventDefault();
    if (
      this.appShell.interactors.session.selectors.isAuthenticated(
        this.appShell.interactors.session.getState()
      )
    ) {
      this.updStore.dispatch(actions.router.stateGo(STATES.DASHBOARD));
    } else {
      this.appShell.interactors.router.go('/');
    }
  }
}

const UPDATER = {
  id: 1,
  name: 'Updater',
  logo_id: 'updater_logo',
};

const isntUpdater = (entity) => entity.id !== UPDATER.id;

function mapStateToThis(state) {
  const siteConfig = selectors.current.siteConfig();
  const currentStatenName = selectors.router.currentName(state);

  return {
    companies: siteConfig
      .brandedCompaniesAndDivisions(state)
      .filter(isntUpdater),
    professionals: siteConfig.brandedProfessionals(state),
    showMoverDropdown: currentStatenName !== STATES.SIGN_IN,
    updater: UPDATER,
  };
}

export const AppHeaderComponent = {
  controller: AppHeaderController,
  template,
};
